import { render, staticRenderFns } from "./StatusTabsAllFase.vue?vue&type=template&id=3014a086&"
import script from "./StatusTabsAllFase.vue?vue&type=script&lang=ts&"
export * from "./StatusTabsAllFase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports